module.exports = __webpack_public_path__ + "static/SocialDrop-2-light-1f7746c74398d8a7563229da093ded47.svg";